export class ModeContact {

    mct_id: string;
    mct_libelle: string;

    constructor(data?: any) {
        if (!data) {
            data = [];
        }

        this.mct_id         = data['mct_id'] ? data['mct_id'] : null;
        this.mct_libelle    = data['mct_libelle'] ? data['mct_libelle'] : null;
    }

}
